export const data = {
  items: [
    {
      id: "item-1",
      index: 0,
      sources: [
        "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"
      ],
      thumb: "//picsum.photos/id/200/500/700",
      name: "Big Buck Bunny"
    },
    {
      id: "item-2",
      index: 1,
      sources: [
        "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4"
      ],
      thumb: "//picsum.photos/id/201/500/700",
      name: "Elephant Dream"
    },
    {
      id: "item-3",
      index: 2,
      sources: [
        "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4"
      ],
      thumb: "//picsum.photos/id/202/500/700",
      name: "For Bigger Blazes"
    },
    {
      id: "item-4",
      index: 3,
      sources: [
        "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4"
      ],
      thumb: "//picsum.photos/id/203/500/700",
      name: "For Bigger Escape"
    },
    {
      id: "item-5",
      index: 4,
      sources: [
        "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4"
      ],
      thumb: "//picsum.photos/id/204/500/700",
      name: "For Bigger Fun"
    },
    {
      id: "item-6",
      index: 5,
      sources: [
        "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4"
      ],
      thumb: "//picsum.photos/id/305/500/700",
      name: "For Bigger Joyrides"
    },
    {
      id: "item-7",
      index: 6,
      sources: [
        "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerMeltdowns.mp4"
      ],
      thumb: "//picsum.photos/id/206/500/700",
      name: "For Bigger Meltdowns"
    },
    {
      id: "item-8",
      index: 7,
      sources: [
        "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/Sintel.mp4"
      ],
      thumb: "//picsum.photos/id/307/500/700",
      name: "Sintel"
    },
    {
      id: "item-9",
      index: 8,
      sources: [
        "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/SubaruOutbackOnStreetAndDirt.mp4"
      ],
      thumb: "//picsum.photos/id/208/500/700",
      name: "Subaru Outback On Street And Dirt"
    },
    {
      id: "item-10",
      index: 9,
      sources: [
        "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/TearsOfSteel.mp4"
      ],
      thumb: "//picsum.photos/id/209/500/700",
      name: "Tears of Steel"
    },
    {
      id: "item-11",
      index: 10,
      sources: [
        "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/VolkswagenGTIReview.mp4"
      ],
      thumb: "//picsum.photos/id/210/500/700",
      name: "Volkswagen GTI Review"
    },
    {
      id: "item-12",
      index: 11,
      sources: [
        "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/WeAreGoingOnBullrun.mp4"
      ],
      thumb: "//picsum.photos/id/211/500/700",
      name: "We Are Going On Bullrun"
    },
    {
      id: "item-13",
      index: 12,
      sources: [
        "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/WhatCarCanYouGetForAGrand.mp4"
      ],
      thumb: "//picsum.photos/id/212/500/700",
      name: "What care can you get for a grand?"
    },
    {
      id: "item-14",
      index: 13,
      sources: [
        "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"
      ],
      thumb: "//picsum.photos/id/213/500/700",
      name: "Big Buck Bunny"
    },
    {
      id: "item-15",
      index: 14,
      sources: [
        "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4"
      ],
      thumb: "//picsum.photos/id/214/500/700",
      name: "Elephant Dream"
    },
    {
      id: "item-16",
      index: 15,
      sources: [
        "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4"
      ],
      thumb: "//picsum.photos/id/215/500/700",
      name: "For Bigger Blazes"
    },
    {
      id: "item-17",
      index: 16,
      sources: [
        "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4"
      ],
      thumb: "//picsum.photos/id/216/500/700",
      name: "For Bigger Escape"
    },
    {
      id: "item-18",
      index: 17,
      sources: [
        "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4"
      ],
      thumb: "//picsum.photos/id/217/500/700",
      name: "For Bigger Fun"
    },
    {
      id: "item-19",
      index: 18,
      sources: [
        "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4"
      ],
      thumb: "//picsum.photos/id/218/500/700",
      name: "For Bigger Joyrides"
    },
    {
      id: "item-20",
      index: 19,
      sources: [
        "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerMeltdowns.mp4"
      ],
      thumb: "//picsum.photos/id/219/500/700",
      name: "For Bigger Meltdowns"
    },
    {
      id: "item-21",
      index: 20,
      sources: [
        "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/Sintel.mp4"
      ],
      thumb: "//picsum.photos/id/220/500/700",
      name: "Sintel"
    },
    {
      id: "item-22",
      index: 21,
      sources: [
        "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/SubaruOutbackOnStreetAndDirt.mp4"
      ],
      thumb: "//picsum.photos/id/221/500/700",
      name: "Subaru Outback On Street And Dirt"
    },
    {
      id: "item-23",
      index: 22,
      sources: [
        "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/TearsOfSteel.mp4"
      ],
      thumb: "//picsum.photos/id/222/500/700",
      name: "Tears of Steel"
    },
    {
      id: "item-24",
      index: 23,
      sources: [
        "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/VolkswagenGTIReview.mp4"
      ],
      thumb: "//picsum.photos/id/223/500/700",
      name: "Volkswagen GTI Review"
    },
    {
      id: "item-25",
      index: 24,
      sources: [
        "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/WeAreGoingOnBullrun.mp4"
      ],
      thumb: "//picsum.photos/id/324/500/700",
      name: "We Are Going On Bullrun"
    },
    {
      id: "item-26",
      index: 25,
      sources: [
        "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/WhatCarCanYouGetForAGrand.mp4"
      ],
      thumb: "//picsum.photos/id/225/500/700",
      name: "What care can you get for a grand?"
    }
  ]
};
